import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ErrorInfo from './ErrorInfo'
import {TrackType} from './propTypes'


const EmptyState = () => (
  <div className="embo-player__titlebar embo-player__titlebar--is-empty" role="status">
    <div className="embo-player__titlebar__title">
      <span className="embo-player__titlebar__marquee">
        {'Ajoute des pistes en naviguant sur le site ♫'}
      </span>
    </div>
  </div>
)

const TitleBar = ({
  track,
}) => {
  if (!track) return <EmptyState/>

  const {performer, name, error} = track
  const classes = cx('embo-player__titlebar', {
    'embo-player__titlebar--has-error': !!error,
  })
  const label = performer ? `${performer.name} - ${name}` : name
  const title = performer ? `"${name}", by ${performer.name}` : name

  return (
    <div className={classes} role="status" title={title}>
      <div className="embo-player__titlebar__title">
        {label}
      </div>
      {error && <ErrorInfo error={error}/>}
    </div>
  )
}
TitleBar.propTypes = {
  track: TrackType,
}
export default React.memo(TitleBar, (prevProps, nextProps) => {
  return nextProps.track === prevProps.track
})
